






























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { enums } from '@/common/enums';
import DataPanel from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import PaginationPanel from '@/components/PaginationPanel.vue';
import { DraggerImg } from '@/components';
import { formRules } from '@/common/util/validator';
import ImageNumUpload from '@/components/ImageNumUpload.vue';
import UserDialog from './component/UserDialog.vue';
import permissionsDialog from './component/permissionsDialog.vue';
import BaseContainer from '@/components/BaseContainer.vue';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { UserApi, DepartmentApi, LoginApi } from '@/http';
import { MessageBox, Message } from 'element-ui';
import collapse from '../../utils/collapse';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        PaginationPanel,
        ImageNumUpload,
        UserDialog,
        permissionsDialog,
        BaseContainer,
        ListFilterPanel,
        collapse,
        PageDescribe,
        SearchPanel,
        DraggerImg,
    },
})
export default class UserMangement extends Vue {
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        form: HTMLFormElement;
        ImageNumUpload: HTMLFormElement;
        UserDialog: HTMLFormElement;
        permissionsDialog: HTMLFormElement;
        tree: HTMLFormElement;
        selectTree: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public isStatusType = enums.isStatusType;
    public departmentList = [];
    // public enabledList = [true];
    public isActive: boolean = false;
    public rePagin: boolean = false;
    public total: number = 0;
    public labelPosition: string = 'right';
    public title: string = '';
    // 验证规则
    public formRules = formRules;
    public form: any = {};
    public searchValue: any = {
        departmentId: '',
        enabled: true,
        realName: '',
        userName: '',
        phoneNumber: '',
        departmentName: '',
    };
    public loading: boolean = false;
    public listData = [];
    public treeData = [];
    public dialogConfig: any = {
        title: '',
        show: false,
    };

    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    mounted() {
        this.$refs.draggerImg.imgdrager();
        this.loadDataList();
        this.loadAllPermissions();
        this.loadDepartList();
        // this.search();
    }
    //获取部门信息
    public async loadDepartList() {
        await DepartmentApi.GetDepartmentList('').then((res) => {
            this.departmentList = res;
        });
    }
    public defaultProps = {
        label: (data, node) => {
            return data.name ? data.name : data.userName;
        },
        children: 'childrenList',
    };
    //节点点击事件
    // handleClickNode(data) {
    //     this.searchValue.departmentId = data.id;
    //     this.searchValue.departmentName = data.name ? data.name : data.userName;
    //     // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
    //     this.$refs.selectTree.blur();
    // }
    //获取所有功能权限
    async loadAllPermissions() {
        await LoginApi.GetPermissionTree({ type: 1 })
            .then((res) => {
                this.treeData = res.permissions;
            })
            .catch((err) => {});
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.loadDataList();
    }
    public async loadDataList() {
        this.loading = true;
        await UserApi.GetUserList({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.listData = res.data;
                let skip = this.searchPagin.skip;
                this.listData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                /**无数据返回上一页 */
                if (this.searchPagin.currentPage > 1) {
                    if (this.listData.length == 0) {
                        this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                        this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                    }
                }
            })
            .catch((err) => {
                this.loading = false;
            });
        if (this.total > 0 && this.listData.length == 0) {
            this.searchPagin.skip = 0;
            this.loadDataList();
        }
    }
    /**获取表格序号*/
    // getIndex($index) {
    //     return (this.searchPagin.currentPage - 1) * this.searchPagin.count + $index + 1;
    // }
    public search() {
        this.loadDataList();
    }
    public reset() {
        // this.enabledList = [];
        this.searchValue = {
            departmentId: '',
            enabled: '',
            realName: '',
            userName: '',
            phoneNumber: '',
            departmentName: '',
        };
        this.loadDataList();
    }
    // 自适应表格列宽
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return;
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return;
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            let index = 0;
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str] === null) {
                    return;
                }
                const now_temp = tableData[i][str] + '';
                const max_temp = tableData[index][str] + '';
                if (now_temp.length > max_temp.length) {
                    index = i;
                }
            }
            columnContent = tableData[index][str];
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 16;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 9;
            }
        }
        if (flexWidth < 160) {
            // 设置最小宽度
            flexWidth = 160;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 10 + 'px';
    }
    //部门关键字查询
    typeFilter(value) {
        this.$refs.tree.filter(value);
    }
    filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }

    public colData = JSON.parse(sessionStorage.getItem('UserMangeMent_colData'))
        ? JSON.parse(sessionStorage.getItem('UserMangeMent_colData'))
        : [
              { title: '序号', isShow: true, disabled: false },
              { title: '用户名', isShow: true, disabled: false },
              { title: '姓名', isShow: true, disabled: false },
              { title: '手机号', isShow: true, disabled: false },
              { title: '所属部门', isShow: true, disabled: false },
              { title: '角色', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        sessionStorage.setItem('UserMangeMent_colData', JSON.stringify(this.colData));
    }
    tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 2 == 0) {
            return '';
        }
        return 'success-row';
    }
    public addUser() {
        this.title = '新增员工';
        this.$refs.UserDialog.addOpen();
    }
    public edit(row) {
        this.title = '编辑员工';
        this.$refs.UserDialog.editOpen(row.id);
    }
    public permissionsEdit(row) {
        this.$refs.permissionsDialog.open(row.id);
    }
    public operateEdit(row) {
        this.$refs.permissionsDialog.operateOpen(row.id);
    }
    public srow: any;
    public del(row) {
        this.srow = row;
        this.dialogConfig = {
            title: '删除该用户',
            show: true,
        };
        // this.$confirm('被删除的用户账号将无法登录本系统，确认删除用户吗？', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning',
        // }).then(() => {
        //     UserApi.DeleteUser(row.id).then(() => {
        //         this.$message({
        //             type: 'success',
        //             message: '删除成功!',
        //         });
        //         this.loadDataList();
        //     });
        // });
    }
    async confirmOk() {
        UserApi.DeleteUser(this.srow.id).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!',
            });
            this.loadDataList();
        });
        this.dialogConfig = {
            show: false,
        };
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.ASC = true;
        } else {
            this.searchValue.ASC = false;
        }
        switch (col.prop) {
            case 'userName':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
        }
        this.loadDataList();
    }
}
